"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const lodash_1 = __importDefault(require("lodash"));
const API = {
    detail: (configKey) => `/blockpass_console/v1/runtimeconfigs/${configKey}`,
    listMicroHost: '/blockpass_console/v1/micro/hosts',
};
class RunTimeConfigAPI {
    constructor(httpClient, config) {
        this._httpClient = httpClient;
        this._baseURL = config.baseURL;
    }
    async getConfigDetail(configKey) {
        const data = {
            result: null,
            entities: {},
        };
        const res = await this._httpClient.get(API.detail(configKey), {
            baseURL: this._baseURL,
        });
        if (!res.data || !res.data.data) {
            return data;
        }
        const resBody = res.data.data;
        data.result = resBody.key;
        data.entities = { runtimeConfigs: { [resBody.key]: resBody } };
        return data;
    }
    async getListMicroFrontendHost() {
        const data = {
            result: null,
            entities: {},
        };
        const res = await this._httpClient.get(API.listMicroHost, {
            baseURL: this._baseURL,
        });
        if (!res.data || !res.data.data) {
            return data;
        }
        const resBody = res.data.data;
        data.result = resBody.map((val) => val.key);
        data.entities = { runtimeConfigs: lodash_1.default.keyBy(resBody, 'key') };
        return data;
    }
}
exports.default = RunTimeConfigAPI;
